import { render, staticRenderFns } from "./DoctorConsultationsInfoModal.vue?vue&type=template&id=55a782ba&scoped=true"
import script from "./DoctorConsultationsInfoModal.vue?vue&type=script&lang=js"
export * from "./DoctorConsultationsInfoModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorConsultationsInfoModal.vue?vue&type=style&index=0&id=55a782ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a782ba",
  null
  
)

export default component.exports